<table>
    <thead>
        <tr>
            <th class="subtable id">ID</th>
            <th class="subtable string">{{'consumos.table.tabs.confeccion.confeccion' | translate}}</th>
            <th class="subtable number" *ngIf="confeccion.tipoConfeccionId == 1">{{'consumos.table.tabs.confeccion.pesoCaja' | translate}}</th>
            <th class="subtable number" *ngIf="confeccion.tipoConfeccionId != 1">{{'consumos.table.tabs.confeccion.pesoKg' | translate}}</th>
            <th class="subtable number" *ngIf="confeccion.tipoConfeccionId == 1">{{'consumos.table.tabs.confeccion.envasesCaja' | translate}}</th>
            <th class="subtable number" *ngIf="confeccion.tipoConfeccionId != 1">{{'consumos.table.tabs.confeccion.numCaja' | translate}}</th>
            <th class="subtable icon">{{'consumos.table.tabs.confeccion.mix' | translate}}</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td class="id">{{confeccion.id}}</td>
            <td class="string">{{confeccion.des}}</td>
            <td class="number" *ngIf="confeccion.tipoConfeccionId == 1">{{confeccion.cajasConfeccion[0].caja.kilos | number : '1.2-2': defaultLanguage}}</td>
            <td class="number" *ngIf="confeccion.tipoConfeccionId != 1">{{confeccion.kilos | number : '1.2-2': defaultLanguage}}</td>
            <td class="number" *ngIf="confeccion.tipoConfeccionId == 1">{{confeccion.cajasConfeccion[0].numEnvasesCaja | number : '1.0-0': defaultLanguage}}</td>
            <td class="number" *ngIf="confeccion.tipoConfeccionId != 1">{{numCajasConfeccionPallet | number : '1.0-0': defaultLanguage}}</td>
            <td class="icon">
                <i *ngIf="!mix" class="fa-regular fa-check-circle" title="{{'titles.confeccionMix' | translate}}"></i>
                <i *ngIf="mix" style="color:red" class="fa-regular fa-circle-xmark" title="{{'titles.confeccionEstandar' | translate}}"></i>
            </td>
        </tr>
    </tbody>
</table>
